import { lazy } from 'react';
import {
  Boxes,
  Factory,
  Kanban, Layers,
  LayoutDashboard,
  ListChecks,
  Users,
} from 'lucide-react';

const LandingPage = lazy(() => import('../views/public/LandingPage'));
const FeedbackPage = lazy(() => import('../views/public/FeedbackPage'));
const FeaturesPage = lazy(() => import('../views/public/FeaturesPage'));
const DocsPage = lazy(() => import('../views/public/DocsPage'));
const CGUPage = lazy(() => import('../views/public/CGUPage'));
const ConfidentialitePage = lazy(() => import('../views/public/ConfidentialitePage'));
const MentionsLegalesPage = lazy(() => import('../views/public/MentionsLegalesPage'));
// import TicketCharts from '../views/private/Test';

const Dashboard = lazy(() => import('../views/private/Dashboard'));
const Workspaces = lazy(() => import('../views/private/Workspaces'));
const LoginPage = lazy(() => import('../views/public/LoginPage'));
const CreateGoogleAccount = lazy(() => import('../views/public/CreateGoogleAccount'));
const AuthGoogleAccount = lazy(() => import('../views/public/AuthGoogleAccount'));
const SignUp = lazy(() => import('../views/public/SignUp'));
const CreatePassword = lazy(() => import('../views/public/CreatePassword'));
const Workspace = lazy(() => import('../views/private/Workspace'));
const Profile = lazy(() => import('../views/private/Profile'));
const Projects = lazy(() => import('../views/private/Projects'));
const ProjectSettings = lazy(() => import('../views/private/ProjectSettings'));
const Project = lazy(() => import('../views/private/Project'));
const FactoryView = lazy(() => import('../views/private/FactoryView'));
const Workflows = lazy(() => import('../views/private/Workflows'));
const Workflow = lazy(() => import('../views/private/Workflow'));
const Fields = lazy(() => import('../views/private/Fields'));
const Field = lazy(() => import('../views/private/Field'));
const Screens = lazy(() => import('../views/private/Screens'));
const Screen = lazy(() => import('../views/private/Screen'));
const IssueTypes = lazy(() => import('../views/private/IssueTypes'));
const IssueType = lazy(() => import('../views/private/IssueType'));
const IssueHierarchies = lazy(() => import('../views/private/IssueHierarchies'));
const IssueHierarchy = lazy(() => import('../views/private/IssueHierarchy'));
const ProjectTemplates = lazy(() => import('../views/private/ProjectTemplates'));
const ProjectTemplate = lazy(() => import('../views/private/ProjectTemplate'));
const Issues = lazy(() => import('../views/private/Issues'));
const Issue = lazy(() => import('../views/private/Issue'));
const MyIssues = lazy(() => import('../views/private/MyIssues'));
const BoardConfig = lazy(() => import('../views/private/BoardConfig'));
const ArchivedIssue = lazy(() => import('../views/private/ArchivedIssue'));
const WorkspaceConfig = lazy(() => import('../views/private/WorkspaceConfig'));
const WorkspaceRoleDetail = lazy(() => import('../views/private/WorkspaceRoleDetail'));
const WorkspaceMemberDetail = lazy(() => import('../views/private/WorkspaceMemberDetail'));
const WorkspaceTeamDetail = lazy(() => import('../views/private/WorkspaceTeamDetail'));

const privateViewList = [
  {
    path: '/workspaces',
    label: 'workspaces',
    Component: Workspaces,
    Logo: Layers,
  },
  {
    path: '/:currentWorkspace/myTickets',
    label: 'myTickets',
    Component: MyIssues,
    Logo: ListChecks,
  },
  {
    path: '/:currentWorkspace/myTickets/:key',
    label: 'myTicket',
    Component: MyIssues,
    isNotSideBar: true,
  },
  {
    path: '/profile',
    label: 'profile',
    Component: Profile,
    isNotSideBar: true,
  },
  {
    path: '/workspaces/:id',
    label: 'workspace',
    Component: Workspace,
    isNotSideBar: true,
  },
  {
    path: '/:id',
    label: 'workspace',
    Component: Workspace,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/dashboard',
    label: 'dashboard',
    Component: Dashboard,
    Logo: LayoutDashboard,
  },
  {
    path: '/:currentWorkspace/projects',
    label: 'projects',
    Component: Projects,
    Logo: Boxes,
  },
  {
    path: '/:currentWorkspace/projects/:name',
    label: 'project',
    Component: Project,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/boards',
    label: 'projectBoards',
    Component: Project,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/boards/:boardName',
    label: 'projectBoards',
    Component: Project,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/gantt',
    label: 'projectGantt',
    Component: Project,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/archives',
    label: 'projectArchives',
    Component: Project,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/archives/:key',
    label: 'archivedIssue',
    Component: ArchivedIssue,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/settings',
    label: 'project',
    Component: ProjectSettings,
    isNotSideBar: true,
  },
  // {
  //   path: '/:currentWorkspace/boards/',
  //   label: 'boards',
  //   Component: Board,
  //   Logo: SquareKanban,
  // },
  {
    path: '/:currentWorkspace/issues',
    label: 'issues',
    Component: Issues,
    Logo: Kanban,
  },
  {
    path: '/:currentWorkspace/issues/:key',
    label: 'issue',
    Component: Issue,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/users',
    label: 'users',
    Component: WorkspaceConfig,
    Logo: Users,
  },
  {
    path: '/:currentWorkspace/factory',
    label: 'factory',
    Component: FactoryView,
    Logo: Factory,
  },
  {
    path: '/:currentWorkspace/factory/workflows',
    label: 'Workflows',
    Component: Workflows,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/workflows/:name',
    label: 'Workflow',
    Component: Workflow,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/fields',
    label: 'Fields',
    Component: Fields,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/fields/:key',
    label: 'Field',
    Component: Field,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/screens',
    label: 'Screens',
    Component: Screens,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/screens/:name',
    label: 'Screens',
    Component: Screen,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/issueTypes',
    label: 'IssueTypes',
    Component: IssueTypes,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/issueTypes/:name',
    label: 'IssueType',
    Component: IssueType,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/issueHierarchies',
    label: 'IssueHierarchies',
    Component: IssueHierarchies,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/issueHierarchies/:name',
    label: 'IssueHierarchies',
    Component: IssueHierarchy,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/projectTemplates',
    label: 'ProjectTemplates',
    Component: ProjectTemplates,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/factory/projectTemplates/:name',
    label: 'ProjectTemplate',
    Component: ProjectTemplate,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/boards/:boardName/boardConfig/columns',
    label: 'ColumnsConfig',
    Component: BoardConfig,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/boards/:boardName/boardConfig/issueTypes',
    label: 'IssueTypesConfig',
    Component: BoardConfig,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/boards/:boardName/boardConfig/settings',
    label: 'BoardSettings',
    Component: BoardConfig,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/projects/:name/boards/:boardName/boardConfig',
    label: 'BoardConfig',
    Component: BoardConfig,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/users/members',
    label: 'WorkspaceConfigMembers',
    Component: WorkspaceConfig,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/users/members/:username',
    label: 'WorkspaceMemberDetail',
    Component: WorkspaceMemberDetail,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/users/teams',
    label: 'WorkspaceConfigTeams',
    Component: WorkspaceConfig,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/users/teams/:name',
    label: 'WorkspaceTeamDetail',
    Component: WorkspaceTeamDetail,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/users/roles',
    label: 'WorkspaceConfigRoles',
    Component: WorkspaceConfig,
    isNotSideBar: true,
  },
  {
    path: '/:currentWorkspace/users/roles/:name',
    label: 'WorkspaceRoleDetail',
    Component: WorkspaceRoleDetail,
    isNotSideBar: true,
  },
];

export const landingViewList = [
  {
    path: '/home',
    label: 'landing',
    Component: LandingPage,
  },
  {
    path: '/feedback/:workspaceName/:projectCode/:backlogName',
    label: 'feedback',
    Component: FeedbackPage,
  },
  {
    path: '/features',
    label: 'features',
    Component: FeaturesPage,
  },
  {
    path: '/docs',
    label: 'docs',
    Component: DocsPage,
  },
  {
    path: '/cgu',
    label: 'cgu',
    Component: CGUPage,
  },
  {
    path: '/confidentialite',
    label: 'confidentialite',
    Component: ConfidentialitePage,
  },
  {
    path: '/mentions-legales',
    label: 'mentions-legales',
    Component: MentionsLegalesPage,
  },
];

export const publicViewList = [
  {
    path: '/login',
    label: 'login',
    Component: LoginPage,
  },
  {
    path: '/createGoogleAccount',
    label: 'createGoogleAccount',
    Component: CreateGoogleAccount,
  },
  {
    path: '/authGoogleAccount',
    label: 'authGoogleAccount',
    Component: AuthGoogleAccount,
  },
  {
    path: '/signup',
    label: 'signup',
    Component: SignUp,
  },
  {
    path: '/createPassword',
    label: 'createPassword',
    Component: CreatePassword,
  },
];

export default privateViewList;
